(function(){
  if (window.__LR_MAPS_ATTACHED__) return;
  window.__LR_MAPS_ATTACHED__ = true;

  function ready(cb){ if (document.readyState === 'complete' || document.readyState === 'interactive') cb(); else document.addEventListener('DOMContentLoaded', cb); }
  function waitForGoogle(cb, tries){ tries=tries||0; if (window.google && google.maps && google.maps.places){ cb(); return; } if (tries>120){ console.error('[LR] Google Maps failed to load'); return; } setTimeout(function(){ waitForGoogle(cb, tries+1); }, 100); }
  function enableField(el){
    if(!el) return;
    el.removeAttribute('disabled');
    el.removeAttribute('aria-disabled');
    el.readOnly = false;
    el.style.pointerEvents = 'auto';
    el.style.opacity = '';
    el.classList.remove('is-disabled');
  }

  function attach(){
    var pickup=document.getElementById('pickupAddress'), dropoff=document.getElementById('dropoffAddress');
    var milesInput=document.getElementById('miles'), baseDistInput=document.getElementById('baseDistanceMi');
    if(!pickup || !dropoff || !milesInput || !baseDistInput){ return false; }

    [pickup,dropoff].forEach(function(el){
      enableField(el); el.setAttribute('autocomplete','off');
      el.addEventListener('focus', function(){ enableField(el); }, {passive:true});
      el.addEventListener('keydown', function(){ enableField(el); }, {passive:true});
      el.addEventListener('click', function(){ enableField(el); }, {passive:true});
    });
    setInterval(function(){ enableField(pickup); enableField(dropoff); }, 1500);

    var txBounds=new google.maps.LatLngBounds(new google.maps.LatLng(25.8371,-106.6456), new google.maps.LatLng(36.5007,-93.5080));
    var sessionToken=new google.maps.places.AutocompleteSessionToken();
    var options={ fields:['address_components','formatted_address','geometry','name','place_id'], types:['address'], componentRestrictions:{country:['us']}, bounds:txBounds, strictBounds:false };
    var ac1=new google.maps.places.Autocomplete(pickup, options);
    var ac2=new google.maps.places.Autocomplete(dropoff, options);
    ac1.setOptions({sessionToken:sessionToken}); ac2.setOptions({sessionToken:sessionToken});

    var dm=new google.maps.DistanceMatrixService();
    var geocoder=new google.maps.Geocoder();

    var baseLoc=null, pLoc=null, dLoc=null;
    geocoder.geocode({ address: '78577', componentRestrictions:{country: 'US'} }, function(results,status){
      if(status==='OK' && results[0]){ baseLoc = results[0].geometry.location; }
    });

    function calcMiles(){
      enableField(pickup); enableField(dropoff);

      if(pLoc && dLoc){
        dm.getDistanceMatrix({ origins:[pLoc], destinations:[dLoc], travelMode:google.maps.TravelMode.DRIVING, unitSystem:google.maps.UnitSystem.IMPERIAL }, function(res,status){
          if(status!=='OK') return;
          try{
            var el=res.rows[0].elements[0];
            if(el.status==='OK'){
              var miles=el.distance.value/1609.344; milesInput.value=miles.toFixed(1);
              milesInput.dispatchEvent(new Event('input', {bubbles:true}));
              if(window.LR && window.LR.updateEstimate) window.LR.updateEstimate(document);
            }
          }catch(e){}
        });
      }
      if(baseLoc && pLoc){
        dm.getDistanceMatrix({ origins:[baseLoc], destinations:[pLoc], travelMode:google.maps.TravelMode.DRIVING, unitSystem:google.maps.UnitSystem.IMPERIAL }, function(res,status){
          if(status!=='OK') return;
          try{
            var el=res.rows[0].elements[0];
            if(el.status==='OK'){
              var miles=el.distance.value/1609.344; baseDistInput.value=miles.toFixed(1);
              baseDistInput.dispatchEvent(new Event('input', {bubbles:true}));
              if(window.LR && window.LR.updateEstimate) window.LR.updateEstimate(document);
            }
          }catch(e){}
        });
      }
    }

    function resetSession(){ sessionToken=new google.maps.places.AutocompleteSessionToken(); ac1.setOptions({sessionToken:sessionToken}); ac2.setOptions({sessionToken:sessionToken}); }
    function onPlace(which){ return function(){
      enableField(pickup); enableField(dropoff);
      var ac=which==='p'?ac1:ac2; var el=which==='p'?pickup:dropoff; var place=ac.getPlace();
      if(place && place.formatted_address) el.value = place.formatted_address;
      var loc=(place && place.geometry && place.geometry.location)?place.geometry.location:null;
      if(!loc){ geocoder.geocode({ address: el.value, componentRestrictions:{country:'US'}, bounds:txBounds }, function(results,status){
        if(status==='OK' && results[0]){ loc=results[0].geometry.location; if(which==='p') pLoc=loc; else dLoc=loc; calcMiles(); }}); resetSession(); return; }
      if(which==='p') pLoc=loc; else dLoc=loc; resetSession(); calcMiles();
    }; }

    ac1.addListener('place_changed', onPlace('p'));
    ac2.addListener('place_changed', onPlace('d'));

    var tId;
    function debounce(fn,wait){ clearTimeout(tId); tId=setTimeout(fn, wait||400); }
    function recalcTyping(){
      enableField(pickup); enableField(dropoff);
      debounce(function(){
        geocoder.geocode({ address: pickup.value, componentRestrictions:{country:'US'}, bounds:txBounds }, function(results,status){
          if(status==='OK' && results[0]){ pLoc=results[0].geometry.location; calcMiles(); }
        });
        geocoder.geocode({ address: dropoff.value, componentRestrictions:{country:'US'}, bounds:txBounds }, function(results,status){
          if(status==='OK' && results[0]){ dLoc=results[0].geometry.location; calcMiles(); }
        });
      }, 450);
    }
    ['input','change','paste','blur','click','keydown'].forEach(function(evt){ pickup.addEventListener(evt,recalcTyping); dropoff.addEventListener(evt,recalcTyping); });

    return true;
  }

  function start(){
    if(!attach()){
      var mo=new MutationObserver(function(){ if(attach()){ mo.disconnect(); } });
      mo.observe(document.body, { childList:true, subtree:true });
    }
  }
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:select', start);
  ready(function(){ waitForGoogle(start); });
})();